// Vue version of language utilities
import { NL, GB, DE, FR } from 'country-flag-icons/string/3x2'

export function showMultiLingualText(text, altText = null, showFirstLanguage = false, currentLocale = null) {
  function isObject(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value)
  }

  if (isObject(text)) {
    if (currentLocale && currentLocale in text && text[currentLocale]) {
      return String(text[currentLocale])
    }

    if (altText) {
      return String(altText)
    }

    if (showFirstLanguage) {
      const firstKey = Object.keys(text)[0]
      if (text[firstKey]) {
        return String(text[firstKey])
      }
    }

    return ""
  }

  return (altText) ? String(altText) : (text ? String(text) : "")
}

export function getCountryFlagByLanguage(languageCode) {
  switch (languageCode.toUpperCase()) {
    case "NL":
      return NL
    case "EN":
      return GB
    case "DE":
      return DE
    case "FR":
      return FR
    case "FY":
      // For Frisian, we'll use a custom SVG (same as React version)
      return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 910 630">
        <defs>
          <path id="pomp" d="M0,12A16.143,16.143 0 0,1 -14,-4A7,8 0 0,1 -7,-12A6,8 0 0,1 -1,-5A1,1 0 1,0 1,-5A6,8 0 0,1 7,-12A7,8 0 0,1 14,-4A16.143,16.143 0 0,1 0,12z" fill="#ee3e34" transform="rotate(34.695) scale(4.625)"/>
        </defs>
        <rect width="910" height="630" fill="#0155a5"/>
        <g fill="#fff" transform="scale(130,90)">
          <path d="M0,3V5L2,7H4z"/>
          <path d="M1,0H0V1L6,7H7V6z"/>
          <path d="M3,0H5L7,2V4z"/>
        </g>
        <use xlink:href="#pomp" x="455" y="315"/>
        <use xlink:href="#pomp" x="91" y="423"/>
        <use xlink:href="#pomp" x="819" y="207"/>
        <use xlink:href="#pomp" x="212.333" y="147"/>
        <use xlink:href="#pomp" x="697.667" y="483"/>
        <use xlink:href="#pomp" x="661.315" y="97.834"/>
        <use xlink:href="#pomp" x="248.685" y="532.166"/>
      </svg>`
    default:
      return languageCode
  }
}

export function hexToRGB(hex, alpha) {
  if (hex) {
    let r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16)

    if (alpha) {
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")"
    } else {
      return "rgb(" + r + ", " + g + ", " + b + ")"
    }
  }
} 